import { DurationComplex, DurationDefault, DurationEnter, DurationLeave, DurationSlow, DurationQuick, } from '../tokens/generated-tokens/javascript/es6';
/**
 * Parses and returns the numeric value (in milliseconds) of a transition duration based on the given type
 *
 * @param {string} type The type of transition duration to retrieve
 * @returns {number} The parsed numeric duration in milliseconds
 */
export function transitionDuration(type) {
    let value = '';
    switch (type) {
        case 'complex': {
            value = DurationComplex;
            break;
        }
        case 'default': {
            value = DurationDefault;
            break;
        }
        case 'enter': {
            value = DurationEnter;
            break;
        }
        case 'leave': {
            value = DurationLeave;
            break;
        }
        case 'slow': {
            value = DurationSlow;
            break;
        }
        case 'quick': {
            value = DurationQuick;
            break;
        }
        default: {
            throw new Error(`Unsupported duration type: ${type}`);
        }
    }
    const parsed = Number.parseInt(value, 10);
    if (Number.isNaN(parsed)) {
        throw new TypeError(`Invalid duration value for '${type}': ${value}`);
    }
    return parsed;
}
